import React, { useState, useEffect } from "react";
import {
  Modal, Box, Button, TextField, Select, MenuItem,
  Grid, Card, CardMedia, Typography, Snackbar, Alert,
  CircularProgress, IconButton
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

import { db } from "../firebase";
import {
  collection, addDoc, getDocs, onSnapshot, query, where,
  orderBy,
  doc,
  getDoc
} from "firebase/firestore";

// ==================== Modal Styling ====================
const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  bgcolor: "#fff",
  boxShadow: 24,
  p: 4,
  borderRadius: 3,
};

function Createpost() {

  // ==================== States ====================
  const [open, setOpen] = useState(false);
  const [type, setType] = useState("image");
  const [title, setTitle] = useState("");
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState("");

  const [division, setDivision] = useState("");
  const [divisions, setDivisions] = useState([]);

  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);

  const [toast, setToast] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  // ==================== Fetch Divisions ====================
  useEffect(() => {
    // Create a query with ordering
    const q = query(collection(db, "bdivisions"), orderBy("division", "asc"));

    const unsub = onSnapshot(q, (snapshot) => {
      const list = snapshot.docs.map((doc) => ({
        id: doc.id,
        name: doc.data().division,
      }));
      setDivisions(list);
      setLoading(false);
    });

    return () => unsub();
  }, []);

  // ==================== Fetch Posts PHP API ====================
  const fetchPosts = async () => {
    setLoading(true);
    try {
      const res = await fetch("https://whatsapp.vspncc.com/fetch_posts.php");
      const data = await res.json();
      setPosts(data);
    } catch (err) {
      showToast("Failed to load posts", "error");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchPosts();
  }, []);

  // ==================== Helper Toast Function ====================
  const showToast = (msg, severity = "success") =>
    setToast({ open: true, message: msg, severity });

  // ==================== File Change ====================
  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    setFile(selected);
    setPreview(URL.createObjectURL(selected));
  };

  // ==================== Save Post ====================
  const handleSubmit = async () => {
    if (!file || !title) return showToast("Add title & select file", "warning");

    setSending(true);

    const formData = new FormData();
    formData.append("title", title);
    formData.append("type", type);
    formData.append("file", file);

    try {
      const res = await fetch("https://whatsapp.vspncc.com/save_post.php", {
        method: "POST",
        body: formData,
      });

      const result = await res.json();
      if (result.status === "success") {
        showToast("Post uploaded successfully");
        resetForm();
        fetchPosts();
      } else {
        showToast(result.message, "error");
      }
    } catch {
      showToast("Upload failed", "error");
    }

    setSending(false);
  };

  const resetForm = () => {
    setOpen(false);
    setTitle("");
    setFile(null);
    setPreview("");
  };

  // ==================== Delete Post ====================
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this post?")) return;

    await fetch("https://whatsapp.vspncc.com/delete_post.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });

    fetchPosts();
  };

  // ==================== Send WhatsApp ====================
  const handleSendWhatsApp = async (post) => {
    if (!division) return showToast("Select division first!", "warning");

    setSending(true);

    try {
      // --- 1. FETCH TOTAL SENT TO CALCULATE BALANCE ---
      const historySnap = await getDocs(
        query(collection(db, "whatsapphistory"), where("status", "==", "sent"))
      );

      const walletDocRef = doc(db, "wallet", "RyHmP8IsqF3kIZMFPtOK");
      const walletSnap = await getDoc(walletDocRef);

      let initialBalance = 0;

      if (walletSnap.exists()) {
        // Ensure we convert the "count" field to a Number in case it's stored as a string
        initialBalance = Number(walletSnap.data().count) || 0;
      } else {
        console.error("Wallet document not found!");
      }
      const totalSent = historySnap.docs.length;
      const currentBalance = initialBalance - totalSent;

      // --- 2. FETCH CONTACTS FOR SELECTED DIVISION ---
      let snapshot;
      if (division === "all") {
        snapshot = await getDocs(collection(db, "contacts"));
      } else {
        const q = query(
          collection(db, "contacts"),
          where("divisionId", "==", division)
        );
        snapshot = await getDocs(q);
      }

      const contacts = snapshot.docs
        .map((doc) => doc.data())
        .filter((c) => c.whatsapp && /^\d{10}$/.test(c.whatsapp.trim()));

      const requiredCredits = contacts.length;

      // --- 3. VALIDATION: CHECK IF BALANCE IS ENOUGH ---
      if (requiredCredits > currentBalance) {
        alert(
          `Insufficient Balance!\n\n` +
          `Remaining Credits: ${currentBalance}\n` +
          `Required for this Campaign: ${requiredCredits}\n\n` +
          `Please top up your wallet to continue.`
        );
        setSending(false);
        return; // ❌ CANCEL THE PROCESS
      }

      if (!contacts.length) {
        showToast("No contacts found!", "warning");
        setSending(false);
        return;
      }

      // --- 4. PROCEED WITH SENDING ---
      if (!window.confirm(`Send campaign to ${requiredCredits} contacts?`)) {
        setSending(false);
        return;
      }

      const wabaid = "1078724415322166";
      const accesstoken = "EAAR3lKsd118BRHVZCSq36LA7oiVuLOcpu1OTC56FI4TQrhWcHRxt1WA0qB9pz2s5XGj3cMSHRecVToFSmZB40ZBl0okJc7tvaT5MWuutuKyxHrIDmsSEpsWtBzZCDCI4gPosZCbrMoFb1ateNuNZBkJvZCl8DxPgnK7cwTZAbmYyCBwZB0HkmoRhzsQ6ulRAbWpJqdwZDZD";

      let success = 0;

      for (let c of contacts) {
        let status = "failed";

        const payload = {
          messaging_product: "whatsapp",
          to: `91${c.whatsapp}`,
          type: "template",
          template: {
            name:
              post.type === "image"
                ? "image_tamplete"
                : post.type === "video"
                  ? "video_template"
                  : "document_template", // ✅ NEW TEMPLATE
            language: { code: "en" },
            components: [
              {
                type: "header",
                parameters: [
                  post.type === "image"
                    ? { type: "image", image: { link: post.image } }
                    : post.type === "video"
                      ? { type: "video", video: { link: post.image } }
                      : { type: "document", document: { link: post.image, filename: "Document" } } // ✅ NEW
                ],
              },
            ],
          },
        };

        try {
          const r = await fetch(
            `https://graph.facebook.com/v25.0/${wabaid}/messages`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accesstoken}`,
              },
              body: JSON.stringify(payload),
            }
          );

          const res = await r.json();
          if (res.messages?.[0]?.id) {
            status = "sent";
            success++;
          }
        } catch {
          status = "failed";
        }

        // Save to history
        await addDoc(collection(db, "whatsapphistory"), {
          mobile: c.whatsapp,
          division,
          postTitle: post.title,
          type: post.type,
          status: status,
          timestamp: new Date().toISOString(),
        });

        await new Promise((res) => setTimeout(res, 300));
      }

      showToast(`Sent successfully to ${success} contacts`);
    } catch (err) {
      console.error(err);
      showToast("Sending failed", "error");
    }

    setSending(false);
  };

  const triggerCampaign = async (post) => {
    if (!division) return showToast("Select division first!", "warning");

    try {
      await fetch(
        "https://us-central1-whatsapp-mmis.cloudfunctions.net/sendWhatsappCampaign",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            postId: post.id,
            postTitle: post.title,
            postType: post.type,
            postMedia: post.image,
            division,
          }),
        }
      );

      showToast("Campaign started in background 🚀");
    } catch {
      showToast("Failed to start campaign", "error");
    }
  };


  // ==================== UI ====================
  return (
    <Box p={3}>
      <Typography variant="h5" fontWeight="bold" mb={2}>
        WhatsApp Campaign 📢
      </Typography>

      <Button variant="contained" startIcon={<AddIcon />} onClick={() => setOpen(true)}>
        Create Campaign
      </Button>

      {/* ==================== Posts List ==================== */}
      {loading ? (
        <Box textAlign="center" mt={4}>
          <CircularProgress />
        </Box>
      ) : (
        <Grid className="row" spacing={2} mt={1}>
          {posts.map((post) => (
            <Grid className="col-sm-3 mb-3" key={post.id}>
              <Card>
                <CardMedia
                  component={post.type === "image" ? "img" : "video"}
                  src={post.image}
                  controls={post.type === "video"}
                  sx={{ height: 250, objectFit: "cover" }}
                />

                <Box p={2}>
                  <Typography fontWeight="bold">{post.title}</Typography>

                  {/* Working MUI Select */}
                  <Select
                    fullWidth
                    value={division}
                    onChange={(e) => setDivision(e.target.value)}
                    displayEmpty
                    sx={{ mt: 1, mb: 1 }}
                  >
                    <MenuItem value="">
                      <em>Select Division</em>
                    </MenuItem>

                    {divisions.map((d) => (
                      <MenuItem key={d.id} value={d.id}>
                        {d.name}
                      </MenuItem>
                    ))}

                    <MenuItem value="all">
                      ⭐ All Contacts
                    </MenuItem>
                  </Select>

                  <Box display="flex" justifyContent="space-between">
                    <IconButton color="success" onClick={() => handleSendWhatsApp(post)}>
                      {sending ? <CircularProgress size={22} /> : <WhatsAppIcon />}
                    </IconButton>

                    <IconButton color="error" onClick={() => handleDelete(post.id)}>
                      <DeleteIcon />
                    </IconButton>
                  </Box>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}

      {/* ==================== Add Post Modal ==================== */}
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box sx={modalStyle}>
          <Typography variant="h6" mb={2}>Add Campaign</Typography>

          <Select
            fullWidth
            value={type}
            onChange={(e) => setType(e.target.value)}
            sx={{ mb: 2 }}
          >
            <MenuItem value="image">Image</MenuItem>
            <MenuItem value="video">Video</MenuItem>
            <MenuItem value="document">Document</MenuItem> {/* ✅ NEW */}
          </Select>

          <TextField
            fullWidth
            label="Campaign Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            sx={{ mb: 2 }}
          />

          <input
            type="file"
            accept={
              type === "image"
                ? "image/*"
                : type === "video"
                  ? "video/*"
                  : ".pdf,.doc,.docx,.xls,.xlsx"
            }
            onChange={handleFileChange}
          />

          {preview && (
            <Card sx={{ mt: 2 }}>
              {type === "image" && (
                <CardMedia component="img" height="200" src={preview} />
              )}

              {type === "video" && (
                <CardMedia component="video" height="200" src={preview} controls />
              )}

              {type === "document" && (
                <Box p={2} textAlign="center">
                  <Typography variant="body2">
                    📄 Document Selected
                  </Typography>
                  <Typography variant="caption">
                    {file?.name}
                  </Typography>
                </Box>
              )}
            </Card>
          )}

          <Button
            fullWidth
            variant="contained"
            sx={{ mt: 2 }}
            disabled={sending}
            onClick={handleSubmit}
          >
            {sending ? <CircularProgress size={22} /> : "Save Campaign"}
          </Button>
        </Box>
      </Modal>

      {/* ==================== Toast ==================== */}
      <Snackbar
        open={toast.open}
        autoHideDuration={3000}
        onClose={() => setToast({ ...toast, open: false })}
      >
        <Alert severity={toast.severity} variant="filled" sx={{ width: "100%" }}>
          {toast.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default Createpost;
